import { GridFields } from 'components';
import { formatToDateTime } from 'helpers';
import { useConvertDateToUserTimezone } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import {
  Field,
  useFormContext,
} from 'modules/client/common/forms/activityForm';

interface Props {
  isBaseForm?: boolean;
  brightCodeEnabled?: boolean;
}

export const ActivitySection = ({
  isBaseForm,
  brightCodeEnabled = false,
}: Props) => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const { convertDateToUserTimezone } = useConvertDateToUserTimezone();

  return (
    <Section datax="activitySection" title={t('client.client.activity.title')}>
      <GridFields>
        <Field.Text
          fullWidth
          readOnly
          disabled={!readOnly}
          label={t('client.client.activity.id.label')}
          name="activity.id"
          placeholder={t('client.client.activity.id.placeholder')}
        />

        <Field.Text
          fullWidth
          readOnly
          disabled={!readOnly}
          label={t('client.client.activity.createdAt.label')}
          name="activity.createdAt"
          placeholder={t('client.client.activity.createdAt.placeholder')}
        />
        {!isBaseForm && (
          <>
            <Field.Text
              fullWidth
              readOnly
              disabled={!readOnly}
              formatValue={(v) =>
                v ? formatToDateTime(convertDateToUserTimezone(v as Date)) : v
              }
              label={t('client.client.activity.lastSessionDate.label')}
              name="activity.lastSessionDate"
              placeholder={t(
                'client.client.activity.lastSessionDate.placeholder'
              )}
            />

            <Field.Text
              fullWidth
              readOnly
              disabled={!readOnly}
              label={t('client.client.activity.ip.label')}
              name="activity.ip"
              placeholder={t('client.client.activity.ip.placeholder')}
            />

            <Field.Text
              fullWidth
              readOnly
              disabled={!readOnly}
              label={t('client.client.activity.userAgent.label')}
              name="activity.userAgent"
              placeholder={t('client.client.activity.userAgent.placeholder')}
            />
          </>
        )}
        {brightCodeEnabled && (
          <Field.Text
            fullWidth
            readOnly
            disabled={!readOnly}
            label={t('client.client.activity.brightCode.label')}
            name="activity.brightCode"
            placeholder={t('client.client.activity.brightCode.placeholder')}
          />
        )}
      </GridFields>
    </Section>
  );
};
